import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "line",
  "use": "line-usage",
  "viewBox": "0 0 998.05 634.21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 998.05 634.21\" id=\"line\"><path d=\"M869.22 0a128.83 128.83 0 00-128.83 128.83c0 2.46.08 4.91.21 7.35L210.52 405.77a128.83 128.83 0 1047.13 99.61q0-3.7-.21-7.35l530.08-269.59A128.83 128.83 0 10869.22 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/line.svg
// module id = VeCx
// module chunks = 1